import React from "react";

const BackgroundWrapper = ({ children, bgImage }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${bgImage}) no-repeat center center fixed`, // Image as background
        backgroundSize: "cover", // Automatically adjust image size (or change to 'cover' or 'contain' based on your needs)
        backgroundRepeat: "repeat", // Repeats the image if it's smaller than the container
        backgroundPosition: "top left", // Keeps the image positioned at the top-left
       
      
        minHeight: "100vh", // Ensures background spans the full height of the viewport
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundWrapper;
